import React from 'react';
import styles from './Style.module.css'

export const Logo = ({ customClass, src }) => {
  return (
    <div className={`${styles.logo} ${customClass}`}>
        <img src={src} alt='Natureland' title='Natureland'/>
    </div>
  )
}
